import React, { useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import NewMappingReq from "./NewMappingReq";
import BulkUpload from "./BulkUpload";
import MyRequests from "./MyRequests";
import Confirmation from "./Confirmation";

function DealerMapMakerTabs(props) {
const [activeTab, setActiveTab] = useState("newMap");
const [showConfirmation, setShowConfirmation] = useState(false);
const [confirmationData, setConfirmationData] = useState({});

const handleTabChange = (tab) => {
  setActiveTab(tab);
  if (tab !== "newMap") {
    setShowConfirmation(false);
    setConfirmationData({});
  }
};

    return (
        <div className="dealer-mapping-main">
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="dealermap-main-content">
                <div className="tab-content card-box cl-mapping-tab" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "newMap" ? "active" : ""}`}
                                            id="newMap-tab"
                                            data-toggle="tab"
                                            data-target="#newMap"
                                            type="button"
                                            role="tab"
                                            aria-controls="newMap"
                                            aria-selected="true"
                                            onClick={()=> handleTabChange("newMap")}
                                        >
                                            New Mapping Request
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className={`nav-link ${activeTab === "bulkUpload" ? "active" : ""}`}
                                            id="bulkUpload-tab"
                                            data-toggle="tab"
                                            data-target="#bulkUpload"
                                            type="button"
                                            role="tab"
                                            aria-controls="bulkUpload"
                                            aria-selected="false"
                                            onClick={()=> handleTabChange("bulkUpload")}
                                        >
                                            Bulk Upload
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            // className="nav-link"
                                            className={`nav-link ${activeTab === "myReq" ? "active" : ""}`}
                                            id="myReq-tab"
                                            data-toggle="tab"
                                            data-target="#myReq"
                                            type="button"
                                            role="tab"
                                            aria-controls="myReq"
                                            aria-selected="false"
                                            onClick={()=> handleTabChange("myReq")}
                                        >
                                            My Requests
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                        {activeTab === "newMap" &&
                                        (showConfirmation ? (
                                            <Confirmation
                                            confirmationData={confirmationData}
                                            // setActiveTab={setActiveTab}
                                            handleTabChange={handleTabChange}
                                            onNewUpload={() => {
                                                setShowConfirmation(false);
                                                setActiveTab("newMap");
                                            }}
                                            />
                                        ) : (
                                            <NewMappingReq
                                            setActiveTab={setActiveTab}
                                            setShowConfirmation={setShowConfirmation}
                                            setConfirmationData={setConfirmationData}
                                            />
                                        ))}
                                        {activeTab === "bulkUpload" && (
                                            <BulkUpload 
                                            handleTabChange={handleTabChange}/>
                                        )}
                                         {activeTab === "myReq" && (
                                            <MyRequests setActiveTab={setActiveTab} />
                                         )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default DealerMapMakerTabs;
